import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { Route, Routes } from "react-router-dom";
import { PageLoader } from "./components/page-loader";
import { AuthenticationGuard } from "./components/authentication-guard";
import { PageCallback } from "./pages/page-callback";
import { PageNotFound } from "./pages/page-not-found";
import { PageProfile } from "./pages/page-profile";
import { PagePublic } from "./pages/page-public";
import {PageUtils} from "./pages/admin/page-utils";
import {PageCompanyInfos} from "./pages/admin/page-company-infos";
import {PageCSE} from "./pages/admin/page-cse";
import { PageRepresentation } from "./pages/admin/page-representation";

export const App = () => {
    const { isLoading } = useAuth0();

    if (isLoading) {
        return (
            <div className="page-layout">
                <PageLoader />
            </div>
        );
    }

    return (
        <Routes>
            <Route path="/" element={<PagePublic />} />
            <Route
                path="/profile"
                element={<AuthenticationGuard component={PageProfile} />}
            />
            <Route
                path="/company"
                element={<AuthenticationGuard component={PageCompanyInfos} />}
            />
            <Route
                path="/cse"
                element={<AuthenticationGuard component={PageCSE} />}
            />
            <Route
                path="/utils"
                element={<AuthenticationGuard component={PageUtils} />}
            />
            <Route
                path="/representation"
                element={<AuthenticationGuard component={PageRepresentation} />}
            />
            <Route path="/callback" element={<PageCallback />} />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
};
